import m from "../../geodata/es2015/kosovoHigh";
window.am4geodata_kosovoHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/kosovoHigh.js
// module id = null
// module chunks = 